import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Span } from "../../Text/index.js";
import { autocompleteListItemVariants } from "./AutocompleteListItem.variant.js";
const AutocompleteListItem_AutocompleteListItem = /*#__PURE__*/ forwardRef(function({ leftNode, firstLine, secondLine, rightNode, isSelected, isHighlighted, isHighlightedIndexWithKeyArrow, ...props }, ref) {
    const { itemWrapperSlot, leftNodeIconWrapperSlot, leftNodeAndTextSlot, textSlot, rightNodeSlot } = autocompleteListItemVariants({
        isSelected,
        isHighlighted,
        isHighlightedIndexWithKeyArrow,
        ...props
    });
    return /*#__PURE__*/ jsxs("li", {
        ref: ref,
        className: itemWrapperSlot(),
        ...props,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: leftNodeAndTextSlot(),
                children: [
                    leftNode && /*#__PURE__*/ jsx("div", {
                        className: leftNodeIconWrapperSlot(),
                        children: leftNode
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: textSlot(),
                        children: [
                            /*#__PURE__*/ jsx(Span, {
                                textStyle: "body2",
                                overflow: "ellipsis",
                                lineClamp: secondLine ? 1 : 2,
                                children: firstLine
                            }),
                            secondLine && /*#__PURE__*/ jsx(Span, {
                                textStyle: "body3",
                                overflow: "ellipsis",
                                children: secondLine
                            })
                        ]
                    })
                ]
            }),
            rightNode && /*#__PURE__*/ jsx("div", {
                className: rightNodeSlot(),
                children: rightNode
            })
        ]
    });
});
export { AutocompleteListItem_AutocompleteListItem as AutocompleteListItem };
